import { useDispatch, useSelector } from "react-redux";

export const Breach = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reducer);

  return (
    <div className="bg-white shadow-sm border rounded-lg">
      <div className="p-6">
        <p className="font-bold text-xl">Claims</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full font-medium text-[#6B707E]">
          <thead className="bg-[#F9FAFB]">
            <tr className="border-t border-b text-muted-foreground text-sm text-left">
              <th className="px-6 py-3 font-medium text-center">Number</th>
              <th className="px-6 py-3 font-medium text-center">Did you record the breach in the 'insurer breach' spreadsheet?</th>
              <th className="px-6 py-3 font-medium text-center">name of the insurer</th>
              <th className="px-6 py-3 font-medium text-center">type of breach</th>
              <th className="px-6 py-3 font-medium text-center">recorded date</th>
              <th className="px-6 py-3 font-medium min-w-[230px] text-center">Email sent date</th>
            </tr>
          </thead>
          <tbody>
            {
              state.breachs?.map((item, index) => {
                return (
                  <tr className="border-t">
                    <td className="px-6 py-4 text-center">{index + 1}</td>
                    <td className="px-6 py-4 text-center">{item.recordedBreach === true ? "Yes" : "No"}</td>
                    <td className="px-6 py-4 text-center">{item.insurerName}</td>
                    <td className="px-6 py-4 text-center">{item.type}</td>
                    <td className="px-6 py-4 text-center">{item.recordedDate.split('T')[0]}</td>
                    <td className="px-6 py-4 text-center">{item.emailDate.split('T')[0]}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};
